import moment from "moment";

import { Popup } from "@/Common/Components/Modals/Popup";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { Person } from "@/Common/Models/Person/Person";

interface IVacationResponderPopupControlProps {
    EmployeesInVacation: Person[];
    containerId: string;
    CancelClickOperation?: number;
    SendClickOperation?: number;

    cancelClickCallback?: () => void;
    sendClickCallback?: () => void;
    isSendLocked?: boolean;
}

class VacationResponderPopupControl extends React.Component<IVacationResponderPopupControlProps, any> {
    public componentDidMount(): void {
        overlayStore.showOverlay("VacationResponderPopupControl");
    }

    public componentWillUnmount(): void {
        overlayStore.hideOverlay("VacationResponderPopupControl");
    }

    public render(): JSX.Element {
        const scrollCss = { maxHeight: "400px", overflowY: "auto" } as React.CSSProperties;

        return (
            <Popup cssClass="double-booking" title={cacheStore.GetString("VacationMessageLabel").replace(":", "")} closeTarget={this.props.CancelClickOperation}>

                <div className="p-body" style={scrollCss}>
                    <div className="row">
                        <div className="col-lg-12">
                            {this.props.EmployeesInVacation.map(p => (
                                <div key={p.ContactId}>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <strong> {p.NameWithPrefix} </strong>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <strong>{cacheStore.GetString("FromLabel")}: </strong>
                                            {p.EmployeeModel.FromVacationDate &&
                                                <span>{moment(p.EmployeeModel.FromVacationDate).format("YYYY/MM/DD")} </span>
                                            }
                                            {!p.EmployeeModel.FromVacationDate &&
                                                <span> -- </span>
                                            }
                                            <strong>{cacheStore.GetString("ToLabel")}: </strong>
                                            {p.EmployeeModel.ToVacationDate &&
                                                <span>{moment(p.EmployeeModel.ToVacationDate).format("YYYY/MM/DD")} </span>
                                            }
                                            {!p.EmployeeModel.ToVacationDate &&
                                                <span> -- </span>
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            {JSXHelper.BreakStringIntoParagraphs(p.EmployeeModel.VacationNote)}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <button data-action="cancel" className="btn btn-default push-right-5" onClick={e => this.handleCancel(e)}>{cacheStore.GetString("CancelLabel")}</button>
                                <button data-action="send" disabled={this.props.isSendLocked} className="btn btn-primary" onClick={e => this.handleSendMessage(e)}>{cacheStore.GetString("SendLabel")}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private handleSendMessage(e: React.MouseEvent): void {
        e.preventDefault();

        if (this.props.sendClickCallback)
            this.props.sendClickCallback();
        else
            sessionStore.dispatch(this.props.SendClickOperation);
    }

    private handleCancel(e: React.MouseEvent): void {
        e.preventDefault();

        if (this.props.cancelClickCallback)
            this.props.cancelClickCallback();
        else
            sessionStore.dispatch(this.props.CancelClickOperation);
    }
}

export { VacationResponderPopupControl };
